/**
 * OrbDocReferenceBehaviorsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceBehaviorsENDocScreen
 */

import { useOrbDocReferenceBehaviorsENDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceBehaviorsENDocScreenLogic';
import type { OrbDocReferenceBehaviorsENDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceBehaviorsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceBehaviorsENDocView as OrbDocReferenceBehaviorsENDocViewEntity } from '@app/shared';
import { OrbDocReferenceBehaviorsENDocBodyView } from '@/components/traits/OrbDocReferenceBehaviorsENDocBodyView';
import { OrbDocReferenceBehaviorsENDocFooterView } from '@/components/traits/OrbDocReferenceBehaviorsENDocFooterView';
import { OrbDocReferenceBehaviorsENDocHeaderView } from '@/components/traits/OrbDocReferenceBehaviorsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceBehaviorsENDocScreenViewProps {
  config?: Partial<OrbDocReferenceBehaviorsENDocScreenConfig>;
}

export function OrbDocReferenceBehaviorsENDocScreenView({ config: propsConfig }: OrbDocReferenceBehaviorsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceBehaviorsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceBehaviorsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceBehaviorsEN" trait="OrbDocReferenceBehaviorsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceBehaviorsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceBehaviorsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceBehaviorsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceBehaviorsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceBehaviorsENDocScreenView;
